'use client';
import { memo, useMemo } from 'react';
import { BI_TYPE } from './constants/index.mjs';
import { getBiInfoFromProps } from './utils/index.mjs';
import { jsx } from 'react/jsx-runtime';
import ProfileImage from './components/ProfileImage.mjs';
import SymbolImage from './components/SymbolImage.mjs';
import TextImage from './components/TextImage.mjs';
import TextWhiteImage from './components/TextWhiteImage.mjs';
import VerticalIcCardImage from './components/VerticalIcCardImage.mjs';
import VerticalProfileImage from './components/VerticalProfileImage.mjs';

const BiImageMap = {
  [BI_TYPE.PROFILE]: props => /*#__PURE__*/jsx(ProfileImage, {
    ...props
  }),
  [BI_TYPE.SYMBOL]: props => /*#__PURE__*/jsx(SymbolImage, {
    ...props
  }),
  [BI_TYPE.TEXT]: props => /*#__PURE__*/jsx(TextImage, {
    ...props
  }),
  [BI_TYPE.TEXT_WHITE]: props => /*#__PURE__*/jsx(TextWhiteImage, {
    ...props
  }),
  [BI_TYPE.VERTICAL_IC_PLATE]: props => /*#__PURE__*/jsx(VerticalIcCardImage, {
    ...props
  }),
  [BI_TYPE.VERTICAL_PROFILE_PLATE]: props => /*#__PURE__*/jsx(VerticalProfileImage, {
    ...props
  })
};
const BiImage = /*#__PURE__*/memo(_ref => {
  let {
    biId,
    type,
    ...commonProps
  } = _ref;
  // 메모이제이션을 위해 biId를 복사하여 사용. biId는 객체라서 리렌더링에 취약함. Primitive Value를 강제로 꺼내서 메모이제이션 수행
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const memoizedBiId = useMemo(() => ({
    ...biId
  }), [biId?.corpId, biId?.mydataOrgCode, biId?.name]);
  const biInfo = useMemo(() => {
    return getBiInfoFromProps(memoizedBiId);
  }, [memoizedBiId]);
  return BiImageMap[type]({
    biInfo,
    type,
    ...commonProps
  });
});
var BiImage$1 = BiImage;

export { BiImage$1 as default };
